import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NormalizedError } from './error.types';
type SnackType = 'error' | 'warning' | 'info' | 'success';
@Injectable({ providedIn: 'root' })
export class ErrorNotificationService {
    private snack = inject(MatSnackBar);

    show(errOrMsg: NormalizedError | string, durationMs = 6000): void {
        // const message = typeof error === 'string' ? error : error.message;
        const { message, type } = this.map(errOrMsg);
        this.snack.open(message, 'OK', {
            duration: durationMs,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['snackbar-base', `snackbar-${type}`], // <- wichtig
        });
    }

    private map(x: NormalizedError | string): {
        message: string;
        type: SnackType;
    } {
        if (typeof x === 'string') return { message: x, type: 'error' };
        const s = x.status ?? 0;
        if (s >= 500 || s === 0) return { message: x.message, type: 'error' };
        if (s >= 400) return { message: x.message, type: 'warning' };
        return { message: x.message, type: 'info' };
    }
}
